import React from "react";
import style from "./siteReportContext.module.scss";

export default props => {
   return <div className={style.containerContext}>{props.children}</div>;
};
